import ViewMessages from './ViewMessages';

export default ViewMessages;



// WEBPACK FOOTER //
// ./src/pages/ViewMessages/index.jsx